export const COLUMN_QUEUE_CLOSURE = [
  {
    label: 'ID',
    stateValue: 'idNumber',
  },
  {
    label: 'Closure Reason',
    stateValue: 'closureReason',
  },
  {
    label: 'Location',
    stateValue: 'location',
  },
  {
    label: 'Start Date',
    stateValue: 'startDate',
  },
  {
    label: 'End Date',
    stateValue: 'endDate',
  },
  {
    label: 'From',
    stateValue: 'fromTime',
  },
  {
    label: 'To',
    stateValue: 'toTime',
  },

  {
    label: 'Requested By',
    stateValue: 'requestedBy',
  },
  {
    label: 'Requested On',
    stateValue: 'requestedOn',
    sortBy: 'requestedOn',
  },
  {
    label: 'Status',
    stateValue: 'status',
  },
  {
    label: 'Action',
    stateValue: 'action',
  },
];

export const QUEUE_CLOSURE_STATUS = {
  Upcoming: 'Upcoming',
  Ongoing: 'OnGoing',
  Expired: 'Expired',
  Cancelled: 'Cancelled',
};

export const QUEUE_CLOSURE_STATUS_COLOR = {
  [QUEUE_CLOSURE_STATUS.Upcoming]: {
    txt: '#AD5E99',
    background: '#FFE9FB',
  },
  [QUEUE_CLOSURE_STATUS.Ongoing]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
  [QUEUE_CLOSURE_STATUS.Expired]: {
    txt: '#333333',
    background: '#f1f1f1',
  },
  [QUEUE_CLOSURE_STATUS.Cancelled]: {
    txt: '#DB3D49',
    background: '#db3d4929',
  },
};

export const QUEUE_CLOSURE_FILTER = [
  {
    value: 'Upcoming',
    key: 'Upcoming',
  },
  {
    value: 'On Going',
    key: 'OnGoing',
  },
  {
    value: 'Expired',
    key: 'Expired',
  },
  {
    value: 'Cancelled',
    key: 'Cancelled',
  },
];

export const TYPE_MODAL = {
  Edit: 'Edit',
  Create: 'Create',
  View: 'View',
};

export const QUEUE_CLOSURE_REASONS = [
  {
    value: 'No doctor on duty',
    key: 'NoDoctor',
  },
  {
    value: 'Queue already overwhelmed',
    key: 'Overwhelmed',
  },
];

export const REASON_STATUS = {
  NoDoctor: 'No doctor on duty',
  Overwhelmed: 'Queue already overwhelmed',
};
